// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"b98a1593","473":"44a429b1","705":"66c452a5","803":"66c452a5"}[chunkId] + ".chunk.css";
};